import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { useNavigate, Link } from "react-router-dom";
import {
  EditIcon,
  DeleteIcon,
  SearchBlack,
  // SearchIcon,
} from "../../../components/Icons/Icons";
import { groupCameraManagement } from "../../../services/api/GroupCameraManagement";
import useFetchData from "../../../hooks/useFetchData";
import { Alert, Button, Pagination, Loading, Toast } from "../../../components";
import { formatDates, sorterArray } from "../../../utils";
import styles from "./CameraGroup.module.css";
import ModalMoreInfo from "../Camera/ModalMoreDetail";
import NameCol from "../../../components/NameCol";

const cx = classNames.bind(styles);

const CameraGroup = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  // const [isRefresh, setIsRefresh] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [textSearch, setTextSearch] = useState();
  const [dataInput, setDataInput] = useState("");
  const [code, setCode] = useState();
  const ref = React.useRef(null);
  const [showModalMore, setShowModalMore] = useState(false)
  const [dataMore, setDataMore] = useState({ data: [], type: '' })
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const { data, loading, pages } = useFetchData(
    "groupCamera/get-list-groupCamera/",
    {
      page: currentPage,
      size: 10,
      // isRefresh: isRefresh,
      subject_name_group_camera: textSearch,
    },
    "xem danh sách nhóm camera"
  );
  const handleClick = (page) => {
    setCurrentPage(page);
  };
  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };
  const showAlert = (code) => {
    setIsAlert(true);
    setCode(code);
  };
  const onChangeTextSearch = (e) => {
    setDataInput(e.target.value);
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      const data = e.target.value;
      setTextSearch(data);
    }, 300);
  };
  const handleClose = () => {
    setIsAlert(false);
  };
  const handleAdd = async () => {
    try {
      setIsAlert(false);
      const res = await groupCameraManagement.delete(code);
      if (res && res.result) {
        Toast.open("Xóa nhóm camera thành công", "success");
        navigate(0, { replace: true });
      } else {
        Toast.open("Xóa nhóm camera không thành công", "danger");
      }
    } catch (e) {
      if (e.response.status === 403) {
        Toast.open("Bạn không có quyền xóa nhóm camera", "danger")
      }
      else {
        Toast.open("Xóa nhóm camera không thành công")
      }
    }
  };

  const getDataShowMore = (data, type) => {
    setShowModalMore(!showModalMore)
    setDataMore({ data: data, type: type })
  }

  useEffect(() => {
    const newData = data ? data : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData.data, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData.data, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData.data)
          break;
      }
    } else {
      setDataTable(newData.data)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }

  const handleVideInfo = (code) => {
    navigate(`/admin/camera_group/edit_group/${code}`)
  }

  return (
    <>
      {isAlert && (
        <Alert
          type="alert"
          title="Bạn có muốn xóa không"
          onClose={handleClose}
          onOk={handleAdd}
        />
      )}
      <div id="__notification"></div>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Quản trị nhóm Camera</h1>
      </div>
      <div className={cx("content")}>
        <div className={cx("filter")}>
          <div className={cx("search")}>
            <input
              className={cx("search-input")}
              value={dataInput}
              onChange={onChangeTextSearch}
              placeholder="Tìm kiếm..."
            />
            <span className={cx("icon-search")}>
              <SearchBlack />
            </span>
          </div>

          <Link
            style={{ textDecoration: "none" }}
            to="/admin/camera_group/add_group"
          >
            <Button className={cx("btn")} title="Thêm nhóm mới" onClick={() => { return 0 }} />
          </Link>
        </div>
        {!loading ? (
          <>
            <table className={cx("table")}>
              <thead>
                <tr>
                  <th style={{textAlign: 'center'}}>STT</th>
                  <th>
                    <NameCol active={method} title={'Nhóm camera'} handleSort={handleSort} method={'SUBJECT_NAME'} />
                  </th>
                  <th>
                    <div className={cx('number-columns')}>
                      <NameCol active={method} title={'Số lượng camera'} handleSort={handleSort} method={'COUNT_CAM'} />
                    </div>
                  </th>
                  <th>
                    <NameCol active={method} title={'Người tạo'} handleSort={handleSort} method={'EDIT_USER'} />
                  </th>
                  <th>
                    <div className={cx('number-columns')}>
                      <NameCol active={method} title={'Sửa lần cuối'} handleSort={handleSort} method={'EDIT_TIME'} />
                    </div>
                  </th>
                  <th style={{textAlign: 'center'}}>Hành động</th>
                </tr>
              </thead>
              <tbody>
                {dataTable &&
                  dataTable?.length > 0 &&
                  dataTable?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td onClick={() => handleVideInfo(item.CODE)} style={{textAlign: 'center'}}>{index + 1}</td>
                        <td onClick={() => handleVideInfo(item.CODE)}>{item.SUBJECT_NAME}</td>
                        <td onClick={() => getDataShowMore([item.CODE], 'camera')} style={{ textAlign: 'center' }}>
                          <div className={cx('number-columns', 'link', 'center')}>{item.COUNT_CAM}</div>
                        </td>
                        <td onClick={() => handleVideInfo(item.CODE)}>{item.EDIT_USER}</td>
                        <td onClick={() => handleVideInfo(item.CODE)}>
                          <div className={cx('number-columns')}>{formatDates(item?.EDIT_TIME)}</div>
                        </td>
                        <td style={{textAlign: 'center'}}>
                          <button onClick={() => handleVideInfo(item.CODE)}>
                            <EditIcon />
                          </button>
                          <button onClick={(e) => showAlert(item.CODE)}>
                            <DeleteIcon />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </>
        ) : (
          <div className={cx("loading")}>
            <Loading />
          </div>
        )}
        <div className={cx("pagination")}>
          <Pagination
            onClick={handleClick}
            onNext={handleNext}
            onPrevious={handlePrevious}
            currentPage={currentPage}
            pages={pages}
          />
        </div>
      </div>
      {showModalMore && <ModalMoreInfo showModal={getDataShowMore} data={dataMore} />}
    </>
  );
};

export default CameraGroup;
